var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-loader",style:({
        '--sw-loader-size': (_vm.size + "px"),
        '--sw-loader-stroke': (_vm.stroke + "px"),
    })},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-loader__container"},[_c('div',{staticClass:"sw-loader__spinner"})])}]

export { render, staticRenderFns }